import React, { Component, ReactNode } from 'react';

interface ITabsProps {
	children: ReactNode;
	name: string;
	handleSelect: (selectedTab, namespace) => void;
	selectedTab: string;
	className?: string;
}

export default class Tabs extends Component<ITabsProps> {
	componentDidMount() {
		const { children, name, handleSelect } = this.props;

		const selectedTab = this.props.selectedTab || this.findDefault(children);

		handleSelect(selectedTab, name);
	}

	findDefault(children) {
		let firstLink;
		let firstDefaultLink;

		const traverse = (child) => {
			if (!child.props || firstDefaultLink) {
				return;
			}

			if (child.props.tabTo) {
				firstLink = firstLink || child.props.tabTo;
				firstDefaultLink = firstDefaultLink || (child.props.default && child.props.tabTo);
			}

			React.Children.forEach(child.props.children, traverse);
		};

		React.Children.forEach(children, traverse);

		return firstDefaultLink || firstLink;
	}

	transformChildren(children) {
		const { name, handleSelect, selectedTab } = this.props;

		if (typeof children !== 'object') {
			return children;
		}

		return React.Children.map(children, (child) => {
			// check if child is TabLink
			if (child.props && child.props.tabTo) {
				return React.cloneElement(child, {
					handleSelect,
					isActive: child.props.tabTo === selectedTab,
					namespace: name,
				});
			}

			// check if child is TabContent and contentFor prop is equal to selectedTab
			if (child.props && child.props.contentFor) {
				return child.props.contentFor === selectedTab ? child : null;
			}

			// if child is anything else run this method trough its children
			return React.cloneElement(child, {}, this.transformChildren(child.props && child.props.children));
		});
	}

	render() {
		const { children, className } = this.props;

		const tabContent = this.transformChildren(children);

		return <div className={className}>{tabContent}</div>;
	}
}
